import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddOnCardLayoutUI = ({
  'data-test-id': dataTestId,
  'data-selenium-id': dataSeleniumId,
  title,
  pricing,
  subtitle,
  description,
  cta
}) => {
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    "data-test-id": dataTestId,
    "data-selenium-id": dataSeleniumId,
    marginBlockEnd: "400",
    padding: "600",
    borderStyle: "solid",
    borderColor: "border-tertiary-default",
    borderWidth: "100",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: '400',
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginBlockEnd: "100",
            children: title
          }), /*#__PURE__*/_jsxs(Text, {
            as: "div",
            typography: "body-125",
            children: [pricing, subtitle]
          })]
        }), /*#__PURE__*/_jsx(View, {
          blockSize: "1000",
          children: cta
        })]
      }), /*#__PURE__*/_jsx(Small, {
        marginBlockEnd: "200",
        children: description
      })]
    })
  });
};
export default AddOnCardLayoutUI;